// ======================================================================
// File Name       : distributionReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty } from '../utils';
import * as ActionTypes from '../constants/actionTypes/report';
import { RETURN_MAX_NUM } from '../constants';
import { REPORT_STATUS_SUBMITTED } from '../constants/KeyValueConstants';

const INITIAL_STATE = {
  distributionReportList: {
    distributionReports: {
      byItemSecernId: {},
      allItemSecernIds: [],
      recordNum: 0,
    },
    distributionReportListResult: [],
    searchInfo: {
      reportStatusList: [REPORT_STATUS_SUBMITTED],
      reportName: '',
      includeDeadlineReportFlg: 0,
      reportHistorySortType: null, // default not sort
      ascendingDescendingSort: 0, // default value
      startPosition: 0, // default value
      returnMaxNum: RETURN_MAX_NUM, // default value
    },
  },
  distributionReportDetail: {
    searchInfo: {
      userName: '',
      groupSecernId: '',
      managementAuthoritySecernIdList: [],
      userAttributeKeyNum: 1,
      userAttributeSearchText: '',
      userSortType: null,
      ascendingDescendingSort: null,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      showSelectGroup: false,
      groupName: '',
      selectedGroup: {},
    },
    distributionEdittingReport: {},
    userListInfo: [],
    userListIds: {
      byItemSecernId: {},
      allItemSecernIds: [],
      recordNum: 0,
    },
    groupList: [],
    correctorList: [],
    approverList: [],
    updateResult: {},
  },
};

export default function distributionReport(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.DISTRIBUTION_REPORT_SEARCH: {
      const { reportListResult, isSearchReportFirst } = action;
      const { itemReportList, recordNum } = reportListResult;
      const distributionReportList = {
        ...state.distributionReportList,
      };
      let reportNumListInfo = [];
      if (!isSearchReportFirst) {
        const { distributionReports } = distributionReportList;
        itemReportList && itemReportList.forEach((item) => {
          if (distributionReports.byItemSecernId[item.itemReportIdAuto]) {
            item.itemSecernId = distributionReports.byItemSecernId[item.itemReportIdAuto].itemSecernId;
            item.reportName = distributionReports.byItemSecernId[item.itemReportIdAuto].reportName;
            item.reportDeadline = distributionReports.byItemSecernId[item.itemReportIdAuto].reportDeadline;
            item.reportReturnPlanDate = distributionReports.byItemSecernId[item.itemReportIdAuto].reportReturnPlanDate;
          }
        });
      }
      reportNumListInfo = itemReportList &&
      itemReportList.reduce(
        (acc, cur) => {
          acc.byItemSecernId[cur.itemReportIdAuto] = cur;
          acc.allItemSecernIds.push(cur.itemReportIdAuto);
          return acc;
        },
        {
          byItemSecernId: {},
          allItemSecernIds: [],
          recordNum,
        },
      );

      distributionReportList.distributionReports = reportNumListInfo;
      distributionReportList.distributionReportListResult = itemReportList;
      return {
        ...state,
        distributionReportList,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_GET: {
      const { distributionReportListResult } = action;
      const distributionReportList = { ...state.distributionReportList };
      const { distributionReports } = distributionReportList;
      const { allItemSecernIds, byItemSecernId } = distributionReports;
      allItemSecernIds.forEach((itemReportIdAuto) => {
        const itemLearningHistoryReportIdList = [];
        distributionReportListResult.forEach((item) => {
          if (itemReportIdAuto === item.itemReportIdAuto) {
            itemLearningHistoryReportIdList.push(item.itemLearningHistoryReportIdAuto);
          }
        });
        byItemSecernId[itemReportIdAuto].itemLearningHistoryReportIdList = itemLearningHistoryReportIdList;
      });
      return {
        ...state,
        distributionReportList,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_UPDATE_SEARCH_INFO: {
      const { searchInfo } = action;
      const distributionReportList = {
        ...state.distributionReportList,
        searchInfo,
      };
      return {
        ...state,
        distributionReportList,
      };
    }
    case ActionTypes.OPEN_ASSIGNMENT_DISTRIBUTION_REPORT_DIALOG: {
      const { itemReportIdAuto } = action;
      const distributionEdittingReport = itemReportIdAuto
        ? { ...state.distributionReportList.distributionReports.byItemSecernId[itemReportIdAuto] }
        : {};
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        distributionEdittingReport,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_DETAIL_UPDATE_SEARCH_INFO: {
      const { searchInfo } = action;
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        searchInfo,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_DETAIL_UPDATE_USER_LIST_INFO: {
      const { userListInfo } = action;
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        userListInfo,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_USER_LIST_SEARCH: {
      const { userResult } = action;
      const { userList, recordNum } = userResult;
      const userListIds = userList.reduce(
        (acc, cur) => {
          const { userSecernId } = cur;
          acc.byItemSecernId[userSecernId] = cur;
          acc.allItemSecernIds.push(userSecernId);
          return acc;
        },
        {
          byItemSecernId: {},
          allItemSecernIds: [],
          recordNum,
        },
      );
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        userListIds,
        userListInfo: userList,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_CHECKING_COUNT: {
      const { checkerUserList } = action;
      const checkerUserNumList = checkerUserList.reduce(
        (acc, cur) => {
          acc.byCd[cur.checkerUserSecernId] = cur;
          acc.allCds.push(cur.checkerUserSecernId);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      const distributionReportDetail = { ...state.distributionReportDetail };
      distributionReportDetail.userListInfo.forEach((item) => {
        item.reportNum = '';
        if (checkerUserNumList.byCd[item.userSecernId]) {
          item.reportNum = checkerUserNumList.byCd[item.userSecernId].reportNum;
        }
      });
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_GROUP_LIST: {
      const { groupList } = action;
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        groupList,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_AUTHORITY_LIST: {
      const { managementAuthorityList } = action;
      const correctorList = [];
      const approverList = [];
      managementAuthorityList.forEach((item) => {
        if (item.managementFunctionAuthorityInfo &&
          item.managementFunctionAuthorityInfo.scoringManagementAuthority) {
          if (item.managementFunctionAuthorityInfo.scoringManagementAuthority === 1) {
            correctorList.push(item.managementAuthoritySecernId);
          } else if (item.managementFunctionAuthorityInfo.scoringManagementAuthority === 2) {
            approverList.push(item.managementAuthoritySecernId);
          }
        }
      });
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        correctorList,
        approverList,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_UPDATE: {
      const { updateResult } = action;
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        updateResult,
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_RESET_UPDATE_RESULT: {
      const distributionReportDetail = {
        ...state.distributionReportDetail,
        updateResult: {},
      };
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_ASSIGNMENT_RESET_INIT: {
      const { distributionReportDetail } = INITIAL_STATE;
      distributionReportDetail.searchInfo.selectedGroup = {};
      distributionReportDetail.searchInfo.groupName = '';
      return {
        ...state,
        distributionReportDetail,
      };
    }
    case ActionTypes.DISTRIBUTION_REPORT_RESET_INIT: {
      const { distributionReportList } = INITIAL_STATE;
      return {
        ...state,
        distributionReportList,
      };
    }
    default:
      return state;
  }
}
